<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">
      <span *ngIf="importingData.action === 'Add'">Add a new schema</span>
      <span *ngIf="importingData.action !== 'Add'">Edit schema</span>
    </span>
    <mat-icon class="h-24-w-24 cursor-pointer" mat-dialog-close>close</mat-icon>
  </div>

  <ng-container *ngIf="importingData.action === 'Add'; else editBlock">
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Schema</mat-label>
          <input name="schema" matInput [(ngModel)]="schemaData.schema" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Naziv šeme</mat-label>
          <input name="nazivSheme" matInput [(ngModel)]="schemaData.nazivSheme" required />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormValid()"
          [promiseBtn]="adding"
          (click)="addNewSchemaFromDialog()"
        >
          <mat-icon>add</mat-icon>
          <span class="ml-8">Add schema</span>
        </button>
      </div>
    </form>
  </ng-container>

  <ng-template #editBlock>
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Schema</mat-label>
          <input name="schema" matInput [(ngModel)]="schemaDataEdit.schema" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Naziv šeme</mat-label>
          <input name="nazivSheme" matInput [(ngModel)]="schemaDataEdit.nazivSheme" required />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormDirty() || !isFormValid()"
          [promiseBtn]="adding"
          (click)="editSchemaFromDialog()"
        >
          <mat-icon>save</mat-icon>
          <span class="ml-8">Update schema</span>
        </button>
      </div>
    </form>
  </ng-template>
</div>
